import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const CancelIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
      viewBox="0 0 19.053 19.053"
    >
      <g transform="translate(1.026 1.026)">
        <path
          d="M773.483,10.677a8.5,8.5,0,1,1,5.194,10.84A8.509,8.509,0,0,1,773.483,10.677Z"
          transform="translate(-773 -5)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x1="11.592"
          y2="11.592"
          transform="translate(2.685 2.723)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
